import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";

function fromNative(position) {
  return {
    lat: position.coords.latitude,
    lng: position.coords.longitude,
    accuracy: position.coords.accuracy,
    timestamp: position.timestamp,
  };
}

export async function requestLocation() {
  if (Capacitor.isNativePlatform()) {
    let permission = await Geolocation.checkPermissions();
    if (permission.location !== "granted") permission = await Geolocation.requestPermissions();
    if (permission.location !== "granted") throw new Error("LOCATION_DENIED");
    return fromNative(await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 30000,
    }));
  }
  if (!("geolocation" in navigator)) throw new Error("LOCATION_UNSUPPORTED");
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy,
        timestamp: position.timestamp,
      }),
      (error) => reject(new Error(
        error.code === 1 ? "LOCATION_DENIED" : error.code === 2 ? "LOCATION_UNAVAILABLE" : "LOCATION_TIMEOUT"
      )),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  });
}

export function locationErrorMessage(error) {
  const code = error?.message || "LOCATION_UNAVAILABLE";
  if (code === "LOCATION_DENIED") return "Location permission is off. Enable it in browser/app settings or tap Locate Me.";
  if (code === "LOCATION_TIMEOUT") return "Location timed out. Turn on Location Services and try again.";
  if (code === "LOCATION_UNSUPPORTED") return "This browser does not support location.";
  return "Your location is currently unavailable.";
}
